import {
  alerter,
  FormField,
} from '@codev/helix-react';
import PropTypes from 'prop-types';
import React from 'react';
import {
  Col,
  FormControl,
  Grid,
  Row,
} from 'react-bootstrap';
import analytics from '../globalWrappers/analytics.js';
import document from '../globalWrappers/document.js';
import window from '../globalWrappers/window.js';
import browserIsIE from '../utilities/browserIsIE.js';
import breakPromise from '../utilities/breakPromise.js';
import Captcha from '../Captcha.jsx';
import FormPanel from '../FormPanel.jsx';
import Frame from '../Frame.jsx';
import LogoPanel from '../LogoPanel.jsx';
import Panel from '../Panel.jsx';
import PanelDivider from '../PanelDivider.jsx';
import styles from './View.css';
import getAppRoot from '../utilities/getAppRoot.js';

const analyticsCategory = 'Login Page - Username/Password';

class View extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      password: '',
      username: '',
    };
  }

  componentDidMount() {
    let {
      cdnError,
      error,
      success,
    } = this.props;

    if (cdnError) {
      alerter.alert({
        message: cdnError,
        type: 'info',
      });

      analytics({
        category: analyticsCategory,
        action: 'Display Warning',
        label: cdnError,
      });
    }
    if (error) {
      alerter.alert({
        message: error,
        type: 'error',
      });

      analytics({
        category: analyticsCategory,
        action: 'Display Error',
        label: error,
      });
    }
    if (success) {
      alerter.alert({
        message: success,
        type: 'success',
      });

      analytics({
        category: analyticsCategory,
        action: 'Display Success',
        label: success,
      });
    }
  }

  waitForRecaptchaValue = async () => {
    let input = document.getElementById('g-recaptcha-response');

    while (!input || !input.value) {
      await new Promise((resolve) => {
        setTimeout(resolve, 100);
      });
    }
  }

  render() {
    let {
      antiforgeryConfig,
      captchaConfig,
      logoUrl,
    } = this.props;
    let {
      password,
      username,
    } = this.state;

    return (
      <Frame
        title="Control Panel Login"
        style={logoUrl ? null : {minWidth: '390px'}}
      >
        {
          logoUrl &&
          <LogoPanel
            logoUrl={logoUrl}
          />
        }
        {
          logoUrl &&
          <PanelDivider />
        }
        <FormPanel
          className={styles.passwordLoginForm}
          method="post"
          onSubmit={async () => {
            if (window.grecaptcha) {
              window.grecaptcha.execute();
              await this.waitForRecaptchaValue();
            }

            document.getElementsByTagName('form')[0].submit();
            await breakPromise();
          }}
          showCancelButton={false}
          submitIndex={3}
          submitText="Log In"
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            padding: '20px',
          }}
        >
          <Panel
            style={{
              display: 'flex',
              height: '205px',
              marginBottom: '0',
              marginLeft: '20px',
              marginRight: '0',
              paddingRight: '20px',
              width: '100%',
            }}
          >
          <Grid
            fluid
            style={{
              width: '100%'
            }}
          >
            <input
              name={antiforgeryConfig.key}
              type="hidden"
              value={antiforgeryConfig.value}
            />
            <Row>
              <Col xs={12}>
                <FormField
                  isRequired
                  label="Username"
                  value={username}
                  style={{width: browserIsIE() ? '357px' : 'inherit'}}
                >
                  <FormControl
                    autoFocus
                    name="username"
                    onChange={x => this.setState({username: x.target.value})}
                    tabIndex={1}
                    value={username}
                  />
                </FormField>
                <a
                  className={styles.forgotLink}
                  href={`/${getAppRoot()}/recover/username${window.location.search}`}
                  onClick={() => {
                    analytics({
                      category: analyticsCategory,
                      action: 'Forgot Username Link',
                    });
                  }}
                  tabIndex={4}
                >
                  Forgot username?
                </a>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <FormField
                  isRequired
                  label="Password"
                  value={password}
                  style={{width: browserIsIE() ? '357px' : 'inherit'}}
                >
                  <FormControl
                    name="password"
                    onChange={x => this.setState({password: x.target.value})}
                    type="password"
                    tabIndex={2}
                    value={password}
                  />
                </FormField>
                <a
                  className={styles.forgotLink}
                  href={`/${getAppRoot()}/recover/password${window.location.search}`}
                  onClick={() => {
                    analytics({
                      category: analyticsCategory,
                      action: 'Forgot Password Link',
                    });
                  }}
                  tabIndex={5}
                >
                  Forgot password?
                </a>
              </Col>
            </Row>
          </Grid>
          </Panel>
          {
            captchaConfig &&
            <Captcha
              jsSrc={captchaConfig.jsSrc}
              siteKey={captchaConfig.key}
            />
          }
        </FormPanel>
      </Frame>
    );
  }
}

View.propTypes = {
  antiforgeryConfig: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }),
  captchaConfig: PropTypes.shape({
    jsSrc: PropTypes.string,
    key: PropTypes.string,
  }),
  cdnError: PropTypes.string,
  error: PropTypes.string,
  logoUrl: PropTypes.string,
  success: PropTypes.string,
};

export default View;
